// This component is used to host all the available edit pop up windows from components inside GrapesJs canvas
import React from 'react';
import EditPopUpForm from './EditPopUps/Form/EditPopUpForm';
import EditDataListElement from './EditPopUps/List/EditPopUpList';
import EditPopUpGeneral from './EditPopUps/EditPopUpGeneral';
import CreateBlockPopUp from './EditPopUps/CreateBlock/CreateBlockPopUp';

const EditElements = (props) => {
  const { editor, selectedPage, selectedProject, savedPageClicked } = props;

  return (
    <>
      <EditPopUpForm
        editor={editor}
        selectedPage={selectedPage}
        selectedProject={selectedProject}
        savedPageClicked={savedPageClicked}
      />
      <EditDataListElement
        editor={editor}
        savedPageClicked={savedPageClicked}
        selectedPage={selectedPage}
        selectedProject={selectedProject}
      />
      <EditPopUpGeneral
        editor={editor}
        savedPageClicked={savedPageClicked}
        selectedPage={selectedPage}
        selectedProject={selectedProject}
      />
      <CreateBlockPopUp
        editor={editor}
        selectedPage={selectedPage}
        selectedProject={selectedProject}
        savedPageClicked={savedPageClicked}
      />
    </>
  );
};

export default EditElements;
